import axios from 'axios'

// Custom Component
// import DoRefreshToken from '../components/SignIn/DoRefreshToken'
import SignOut from '../components/SignIn/SignOut'

const store = require('store')

const saveDefaultSite = async (site_seq) => {
	const saveSite_api = `/site/save_as_default`
	let result

	try {
		let headers = {
			Authorization: 'Bearer ' + store.get('access_token'),
			site: store.get('site'),
			locale: store.get('locale'),
		}

		result = await axios({
			method: 'post',
			url: process.env.REACT_APP_API_URL_3001 + saveSite_api,
			headers: headers,
			data: { site_seq: site_seq },
		})
		// console.log(result.data)
		return result.data
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			} else {
				throw new Error(error)
			}
		} catch (error) {
			throw new Error(error)
		}
	}
}

const getModule = async () => {
	const getModule_api = `/siteuser/me/accessible-module`
	let result

	console.log(
		'************************************************************************'
	)
	console.log('Login Successful')
	console.log('Site Seqance: ' + store.get('site'))
	console.log('Locale: ' + store.get('locale'))
	console.log('Bearer ' + store.get('access_token'))
	console.log(
		'************************************************************************'
	)

	try {
		let headers = {
			Authorization: 'Bearer ' + store.get('access_token'),
			site: store.get('site'),
			locale: store.get('locale'),
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3001 + getModule_api,
			headers: headers,
		})
		// console.log(result.data)
		return result.data
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			} else {
				throw new Error(error)
			}
		} catch (error) {
			throw new Error(error)
		}
	}
}

const getSite = async () => {
	const getSite_api = '/user/me/accessible-site'
	let result

	try {
		let headers = {
			Authorization: 'Bearer ' + store.get('access_token'),
			site: store.get('site'),
			locale: store.get('locale'),
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3001 + getSite_api,
			headers: headers,
		})

		return result.data
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			} else {
				throw new Error(error)
			}
		} catch (error) {
			throw new Error(error)
		}
	}
}

export { getModule, getSite, saveDefaultSite }
